var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"js-mr-widget-author"},[_vm._v("\n  "+_vm._s(_vm.actionText)+"\n  "),_c('mr-widget-author',{attrs:{"author":_vm.author}}),_vm._v(" "),_c('time',{attrs:{"title":_vm.dateTitle,"data-toggle":"tooltip","data-placement":"top","data-container":"body"}},[_vm._v("\n    "+_vm._s(_vm.dateReadable)+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658e77d0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_author_time.vue
// module id = null
// module chunks = 